import { render } from "./SendEmail.vue?vue&type=template&id=3be31ffb&scoped=true&ts=true"
import script from "./SendEmail.vue?vue&type=script&lang=ts"
export * from "./SendEmail.vue?vue&type=script&lang=ts"

import "./SendEmail.vue?vue&type=style&index=0&id=3be31ffb&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DanhGia_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be31ffb"]])

export default __exports__